<script>
export default {
  name: 'CustomModal',
  inheritAttrs: false
}
</script>

<template>
  <vue-final-modal
      v-slot="{ params, close }"
      v-bind="$attrs"
      classes="modal-container"
      content-class="modal-content"
      v-on="$listeners"
  >
    <span class="tdf-modal__heading">
      <slot name="title"></slot>
    </span>
    <div class="modal__content">
      <slot v-bind:params="params"></slot>
    </div>
      <a class="tdf-link tdf-link--white" href="#" @click.prevent="$emit('cancel', close)">Close</a>
  </vue-final-modal>
</template>

<style scoped lang="scss">
@import '../assets/scss/colours';

::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 30px;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 30px;
  background: $rtt-navy;
  color: white;
  max-width: 600px;
}
.modal__content {
  flex-grow: 1;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
